export default __webpack_public_path__ + "static/media/granny.79b40db7.png";